var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardWrapped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.741455,
    y: 0.5,
    width: 33.7586,
    height: 23,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8691 17.1569C16.6857 18.1852 15.1507 18.806 13.4734 18.806C9.73069 18.806 6.69666 15.7154 6.69666 11.903C6.69666 8.09057 9.73069 5 13.4734 5C15.1507 5 16.6857 5.62075 17.8691 6.64903C19.0524 5.62075 20.5874 5 22.2648 5C26.0074 5 29.0415 8.09057 29.0415 11.903C29.0415 15.7154 26.0074 18.806 22.2648 18.806C20.5874 18.806 19.0524 18.1852 17.8691 17.1569Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.869 17.1569C19.3261 15.8908 20.25 14.0068 20.25 11.903C20.25 9.79917 19.3261 7.91516 17.869 6.64903C19.0524 5.62075 20.5874 5 22.2647 5C26.0074 5 29.0414 8.09057 29.0414 11.903C29.0414 15.7154 26.0074 18.806 22.2647 18.806C20.5874 18.806 19.0524 18.1852 17.869 17.1569Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8691 17.1573C19.3262 15.8911 20.2501 14.0071 20.2501 11.9033C20.2501 9.79954 19.3262 7.91555 17.8691 6.64941C16.4121 7.91555 15.4882 9.79954 15.4882 11.9033C15.4882 14.0071 16.4121 15.8911 17.8691 17.1573Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardWrapped);
export default __webpack_public_path__ + "static/media/mastercard-wrapped.1bc5915afac01401f2998f65320a2f98.svg";
export { ForwardRef as ReactComponent };